let okeResponse = require('okeoke.standardresponse')

export default function discounts(orders) {

  async function distributeDiscountAmount(orderItemList, discountID, discountAmount) {
    let discountOrders = {}
    let remainingAmount = discountAmount
    let itemDiscountResults = []
    for await (let orderItem of orderItemList) {
      let { orderUUID, orderItemUUID } = orderItem
      if (discountOrders[orderUUID] === undefined) {
        let orderRes = await orders.getOrder(orderUUID)
        if (orderRes.success) {
          discountOrders[orderUUID] = orderRes.data
        } else {
          continue
        }
      }
      // setItemDiscount(orderItemUUID, discountID, count, skipValid = false, overridePaid = false, autoApplied = false, remainingAmount = 0)
      let itemRes = discountOrders[orderUUID].itemDiscounts.setItemDiscount(orderItemUUID, discountID, null, false, false, false, remainingAmount)
      itemDiscountResults.push(itemRes)
      if (itemRes.success) {
        remainingAmount = itemRes.data.remainingAmount
      }
      if (remainingAmount <= 0) {
        break
      }
    }
    return okeResponse(true, 200, 'Set', { remainingAmount, itemDiscountResults })
  }

  return {
    distributeDiscountAmount
  }

}